import { inject,Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { graphql, MediaclipMutationUpdateStoreConfigArgs, Store, StoreConfig, UpdateStoreConfigInput } from 'app/shared/graph';
import { GraphDotnetService } from 'app/shared/graph';

@Injectable({ providedIn: 'root' })
export class StoreConfigService {
    private readonly graphDotnetService = inject(GraphDotnetService);

    getStoreConfig(storeId: string): Observable<Store> {
        return this.graphDotnetService.query(graphql`
                query getStoreSettings($storeId: String!) {
                    store(id: $storeId) {
                        label
                        config {
                            defaultLibraryPackage
                            defaultLibraryBranches
                            allowAnonymousRequest
                            isRecentUploadsEnabled
                            isProofingEnabled
                            uploadInBackgroundEnabled
                            trustedExternalPhotoHosts
                            webhookLogEnabled
                            useSecureRenewToken
                            enableThumbnailGeneration
                            cartRedirectionPage {
                                url
                            }
                            exitPage {
                                url
                            }
                            loginPage {
                                url
                            }
                            externalUploaderPage {
                                url
                            }
                            correctionsCompletedPage {
                                url
                            }
                            addToCartEndpoint {
                                url
                                headers {
                                    name
                                    value
                                }
                            }
                            getPriceEndpoint {
                                url
                                headers {
                                    name
                                    value
                                }
                            }
                            getProductsPriceEndpoint {
                                url
                                headers {
                                    name
                                    value
                                }
                            }
                            onProjectDeletedEndpoint {
                                url
                                headers {
                                    name
                                    value
                                }
                            }
                            statusUpdateEndpoint {
                                url
                                headers {
                                    name
                                    value
                                }
                            }
                            getProductQuantitiesEndpoint {
                                url
                                headers {
                                    name
                                    value
                                }
                            }
                            getAlternateProductsEndpoint {
                                url
                                headers {
                                    name
                                    value
                                }
                            }
                            getProductDisplaySettingsEndpoint {
                                url
                                headers {
                                    name
                                    value
                                }
                            }
                            uploadPostProcessingEndpoint {
                                url
                                headers {
                                    name
                                    value
                                }
                            }
                        }
                    }
                }
            `,
            {
                storeId
            }
        ).pipe(map(q => q.store));
    }

    updateStoreConfig(input: UpdateStoreConfigInput): Observable<void> {
        return this.graphDotnetService.mutate<MediaclipMutationUpdateStoreConfigArgs>(
            graphql`
                mutation updateStoreConfig($input: UpdateStoreConfigInput!) {
                    updateStoreConfig(input: $input)
                }
            `,
            { input }
        ).pipe(map(x => x.updateStoreConfig));
    }
}
